"use client";
export const COOKIE_SETTINGS_LOCAL_STORAGE_KEY = 'cookieSettings';

export function localStorageSaveCookieSettings(settings: CookieSettings) {
  localStorage.setItem(COOKIE_SETTINGS_LOCAL_STORAGE_KEY, JSON.stringify(settings));
}

export function localStorageGetCookieSettings(): CookieSettings | null {
  const localData = localStorage.getItem(COOKIE_SETTINGS_LOCAL_STORAGE_KEY);
  if (localData) {
    return JSON.parse(localData);
  }
  return null;
}
